import {
  useEffect,
  useMemo,
  useState,
} from 'react';

import {
  cookieJar,
  uiRoutes,
  useOptimizelyFeature,
} from '@consumer-frontend/nc-api';
import { redirectTo } from '@consumer-frontend/nc-utils';
import { Container } from '@consumer-frontend/shared-ui';

import { NcLoginPageWebComponent } from '../NcLoginPageWebComponent';
import { NcPageWithAlertBanner } from '../NcPageWithAlertBanner';

import '@consumer-bootstrap/brands/netcredit/apply/login-page.scss';

export const NcSigninPage: React.FC = () => {
  const isSigninFeatureEnabled = useOptimizelyFeature('app_redesign_m3_experiment_sign_in_with_password_routing');
  const [initialStep, setInitialStep] = useState(true);
  const shouldRedirect = !isSigninFeatureEnabled;
  const [signinVerificationCode, setSigninVerificationCode] = useState<string>();

  const eventHandlers = useMemo(() => ({
    onLoginFlowRestarted: () => setInitialStep(true),
    onSubmitLoginMFARequired: () => setInitialStep(false),
  }), []);

  useEffect(() => {
    if (shouldRedirect) {
      redirectTo(uiRoutes.legacyAH.signin);

      return;
    }

    setSigninVerificationCode(cookieJar.setSigninVerificationCode());
  }, [shouldRedirect]);

  if (shouldRedirect) {
    return null;
  }

  return (
    <NcPageWithAlertBanner>
      <Container hasBoxShadow className="nc-login-page">
        {initialStep && <h1 className="h3">Sign in to your account.</h1>}
        {signinVerificationCode && <NcLoginPageWebComponent eventHandlers={eventHandlers} code={signinVerificationCode} />}
      </Container>
    </NcPageWithAlertBanner>
  );
};
